import { render, staticRenderFns } from "./ProfessorVinculoCard.vue?vue&type=template&id=a850571e&scoped=true&"
import script from "./ProfessorVinculoCard.vue?vue&type=script&lang=js&"
export * from "./ProfessorVinculoCard.vue?vue&type=script&lang=js&"
import style0 from "./ProfessorVinculoCard.vue?vue&type=style&index=0&id=a850571e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a850571e",
  null
  
)

export default component.exports